import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { catchError, tap } from 'rxjs/operators';
import { Subscription, throwError } from 'rxjs';
import { CountryLegacy, CountryLegacyService as SDKCountryLegacy } from '@adeo/ngx-kozikaza-api/misc/country-legacy';
import { SignupFormLiteService } from './signup-form-lite.service';
import { ToastrService } from 'ngx-toastr';
import { KzIconsRegistryService } from '../../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsInfos } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-infos.icon';
import { kzIconsDiscover } from '../../../../kz-ui/ui/icon/generated-icons/kzIcons-discover.icon';

@Component({
  selector: 'app-signup-form-lite',
  templateUrl: './signup-form-lite.component.html',
  styleUrls: ['./signup-form-lite.component.scss']
})
export class SignupFormLiteComponent implements OnDestroy, OnInit {
  public countriesList: Array<CountryLegacy>;
  public signupForm: UntypedFormGroup;
  public hasError = false;
  public showPassword = false;
  public tmpPhoneCode: number;

  private countriesSubscription: Subscription;

  constructor(
    private fb: UntypedFormBuilder,
    private readonly sdkCountryLegacyService: SDKCountryLegacy,
    public signupFormLiteService: SignupFormLiteService,
    private toastrService: ToastrService,
    private kzIconsRegistryService: KzIconsRegistryService,
  ) {
    this.kzIconsRegistryService.registerIcons([kzIconsInfos, kzIconsDiscover]);
  }

  ngOnInit() {
    this.signupFormLiteService.initForm();
    this.signupForm = this.signupFormLiteService.signupForm;
    this.loadCountries();
  }

  loadCountries(): void {
    this.countriesSubscription = this.sdkCountryLegacyService.getCountries().pipe(
      catchError(err => {
        this.toastrService.error($localize`:@@toast.error_try_again:An error has occurred. Please try again`);
        return throwError(err);
      }),
      tap((data) => {
        this.countriesList = data;
      })
    ).subscribe();
  }

  trackByCode(index, data): number {
    return data ? data.code : undefined;
  }

  isFieldInvalid(name: string): boolean {
    if (!this.signupForm) {
      return false;
    }

    const control = this.signupForm.get(name);
    if (!control) {
      return false;
    }
    return (this.hasError || control.dirty || control.touched) && (control.invalid || control.pending);
  }

  ngOnDestroy() {
    if (this.countriesSubscription && !this.countriesSubscription.closed) {
      this.countriesSubscription.unsubscribe();
    }
  }
}

